export default __webpack_public_path__ + "static/media/photo12.e426d8c9.jpg";